export const PACKAGES_SECTION_TEST_ID = 'packages-setting-section';
export const PACKAGES_TAB_TOGGLE_TEST_ID = 'packages-tab-toggle';
export const PACKAGES_EMPTY_TEST_ID = 'packages-empty';
export const PACKAGES_UPLOAD_BUTTON_TEST_ID = 'packages-upload-button';
export const PACKAGES_ROW_ACTIONS_TEST_ID = 'packages-row-actions';
export const PACKAGES_EXTENSION_ROW_ACTIONS_TEST_ID = 'packages-extension-row-actions';
